/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * WARNING: The files in the src/js/bridges directory are bundle dropins.
 * Please exercise extra caution while modifying paths.
 */

define('explore/badges', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.BadgesFeature);
define('explore/chartInsights', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.ChartInsights);
define('explore/crosshairs', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.CrosshairsFeature);
define('explore/summarizer', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.SummarizerFeature);
define('explore/image-capture', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.ImageCaptureFeature);
define('explore/visTitleFetcher', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.VisTitleFetcherFeature);
define('explore/visProperties', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.ExploreLayoutPropertiesProvider);
define('explore/showByAction', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.ShowByAction);
define('explore/showByView', [ 'explore/bundles/dashboard-extensions.min' ], entry => entry.ShowByView);

define('explore/bundles/dashboard-extensions.bridge', () => {});
